import Layout from '@/layout/Layout.vue'
import { P } from '@/config/permissions'

const perm = [P.GESTION_NUM_FIXE.BROWSE]

const gestionNumFixe = {
  path: '/gestionNumFixe',
  component: Layout,
  name: 'Dash_GestionNumFixe',
  redirect: '/gestionNumFixe',
  meta: {
    icon: 'mdi:phone-outline',
    title: 'Numéros fixes',
    permissions: perm,
  },
  children: [
    {
      path: '',
      name: 'GestionNumFixe',
      component: () => import('@/views/gestionNumFixe/DashGestionNumFixe.vue'),
      // Pas de `noCache` : cet ecran recharge lui-meme ses donnees dans `activated()`,
      // hook qui ne se declenche que sous <keep-alive>. L'en sortir le laisse vide.
      meta: {
        title: 'Numéros fixes',
        icon: 'mdi:phone-outline',
        permissions: perm,
      },
    },
  ],
}

export default gestionNumFixe
